import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about">
      <div className="about-hero">
        <div className="hero-overlay"></div>
        <div className="container">
          <h1>Hakkımızda</h1>
          <p className="hero-slogan">ESR Group Sigorta Aracılık Hizmetleri</p>
        </div>
      </div>

      <div className="about-content">
        <div className="container">
          <section className="about-section">
            <h2>Biz Kimiz?</h2>
            <p>
              ESR Group, sigorta sektöründe edindiği uzun yıllara dayanan deneyimi ve
              uzman kadrosu ile bireysel ve kurumsal müşterilerine güvenilir, yenilikçi
              ve sürdürülebilir çözümler sunan bir sigorta aracılık firmasıdır.
            </p>
            <p>
              Müşteri ihtiyaçlarını doğru analiz ederek, her bir müşterimiz için en uygun
              ve en kapsamlı teminatları sağlamayı hedefleriz. Hizmet anlayışımızın temelinde
              güven, şeffaflık ve süreklilik yer almaktadır.
            </p>
          </section>

          <section className="about-section">
            <h2>Misyonumuz</h2>
            <p>
              Müşterilerimizin yaşamlarını, varlıklarını ve geleceklerini güvence altına alan
              en doğru sigorta çözümlerini sunmak.
            </p>
            <p>
              Hızlı, şeffaf ve güvenilir hizmet anlayışımızla; müşteri beklentilerinin ötesine
              geçerek uzun vadeli iş birlikleri oluşturmak ve sektörde kalite standartlarını yükseltmek.
            </p>
          </section>

          <section className="about-section">
            <h2>Vizyonumuz</h2>
            <p>
              Türkiye genelinde güvenilirliği ve hizmet kalitesiyle öne çıkan, dijital dönüşümü
              benimseyen ve müşteri deneyimini merkeze alan öncü sigorta markalarından biri olmak.
            </p>
            <p>
              Sürekli gelişimi ilke edinerek sektöre yön veren yenilikçi çözümler üretmek.
            </p>
          </section>

          <section className="about-section">
            <h2>Değerlerimiz</h2>
            <div className="values-grid">
              <div className="value-item">
                <h3>Güvenilirlik</h3>
                <p>
                  Tüm hizmet süreçlerimizde dürüstlük ve etik ilkelere bağlı kalarak
                  müşterilerimizin güvenini kazanmak ve korumak.
                </p>
              </div>
              <div className="value-item">
                <h3>Şeffaflık</h3>
                <p>
                  Her aşamada açık, anlaşılır ve doğru bilgilendirme yaparak güvene dayalı
                  iletişim kurmak.
                </p>
              </div>
              <div className="value-item">
                <h3>Müşteri Odaklılık</h3>
                <p>
                  Müşteri ihtiyaçlarını önceliklendirerek kişiye özel çözümler sunmak ve
                  memnuniyeti en üst seviyede tutmak.
                </p>
              </div>
              <div className="value-item">
                <h3>İnovasyon</h3>
                <p>
                  Teknolojik gelişmeleri yakından takip ederek hizmet kalitemizi sürekli
                  artırmak ve yenilikçi çözümler sunmak.
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default About;

